/* PASSWORD RESET WITH TOKEN */

let email = urlParams.get('email');
let checkout_url = urlParams.get('checkout_url');


$(document).on('click', '#changePassword', async function (e) {

  if ($('#CustomerPassword').val().length < 8) {
 $('#changePassword-error span').text("New password should be at least 8 characters long")
      $('#changePassword-error').show();
    return false;
  }
  if ($('#CustomerPassword').val() !== $('#RepeatCustomerPassword').val()) {
 $('#changePassword-error span').text("The passwords do not match")
      $('#changePassword-error').show();
    return false;
  }

  
});


/* LOGIN */

// Login flow: check the email with the EditSuits API first (new / inactive accounts get their own
// message), then hand over to Shopify's normal login, which shows "wrong password" itself on failure.
// Nothing in here may throw before the form is submitted, or the button silently does nothing.
function esShowLoginMessage(which) {
  $('#authDetails').show();
  $('#wrong_pass').toggle(which === 'wrong');
  $('#no_account').css('display', which === 'no_account' ? 'inline' : 'none');
  $('#account_activation').css('display', which === 'activation' ? 'inline' : 'none');
  $('#customer_login button').removeClass('button--loading').prop('disabled', false);
}

function esSubmitShopifyLogin() {
  var form = document.getElementById('customer_login');
  form.setAttribute('action', '/account/login');
  // Native submit: no handlers can cancel it, so the button always does something.
  HTMLFormElement.prototype.submit.call(form);
}

$('#customer_login button').click(function (e) {
  e.preventDefault();
  var email = ($('input[name="customer[email]"]').val() || '').trim();
  var password = $('input[name="customer[password]"]').val() || '';
  $('#wrong_password').hide();

  if (!email || !password) { esShowLoginMessage('wrong'); return; }

  // Klaviyo identify is optional - a missing or blocked Klaviyo script must never stop the login.
  try {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
    else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['identify', { '$email': email }]);
  } catch (err) { /* ignore */ }

  $('#customer_login button').addClass('button--loading').prop('disabled', true);
  $.ajax({
    url: 'https://api.v3.editsuits.com/store/checkUser',
    method: 'POST',
    timeout: 8000,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: { email: email }
  }).done(function (response) {
    if (response && response.status === 'success') {
      if (response.details === 'existing-active') return esSubmitShopifyLogin();
      if (response.details === 'new') return esShowLoginMessage('no_account');
      if (response.details === 'existing-inactive') return esShowLoginMessage('activation');
    }
    if (response && response.status === 'error') return esShowLoginMessage('wrong');
    // Unknown answer: let Shopify decide.
    esSubmitShopifyLogin();
  }).fail(function () {
    // Account-check API down or slow: fall back to Shopify's own login.
    esSubmitShopifyLogin();
  });
});

/* REGISTER */

$('#create_customer button').click(function (e) {
  e.preventDefault()

  $('input').removeClass('withError');
    if ($('[name="customer[first_name]"]').val().length === 0 && !$('[name="customer[first_name]"]').hasClass('withError')) {
        $('[name="customer[first_name]"]').addClass('withError')
    }
    if ($('[name="customer[last_name]"]').val().length === 0 && !$('[name="customer[last_name]"]').hasClass('withError')) {
        $('[name="customer[last_name]"]').addClass('withError')
    }
    if ($('[name="customer[password]"]').val().length === 0 && !$('[name="customer[password]"]').hasClass('withError')) {
        $('[name="customer[password]"]').addClass('withError')
    }
    if ($('[name="customer[email]"]').val().indexOf('@') < 0 || $('[name="customer[email]"]').val().indexOf('.') < 0 && !$('[name="customer[email]"]').hasClass('withError')) {
        $('[name="customer[email]"]').addClass('withError')
    }


  _learnq.push(['identify', {
    // Change the line below to dynamically print the user's email.
    '$email' : $('[name="customer[email]"]').val()
  }]);

    if ($('input.withError').length > 0) return false;

 

  var settings = {
    "url": "https://api.v3.editsuits.com/store/checkUser",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    "data": {
      "email": $('input[name="customer[email]"]').val()
    }
  };

  $('#create_customer button').addClass('button--loading');
  $.ajax(settings).done(async function (response) {
  
    $('#registerError').hide();
    if (response.status == 'error') {
      $('#create_customer button').removeClass('button--loading');
      $('#registerError span').text(response.details);
      $('#registerError').show();
    }
    if (response.status == "success") {

      $('#create_customer button').removeClass('button--loading');

      if (response.details === 'existing-active') {

        $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#existing_account').css('display', 'inline');
         $('#account_activation').hide();
       
        
      }

      if (response.details === 'new') {
 
        $('#create_customer').attr('action', '/account');
        $('#create_customer').trigger('submit');
        setTimeout(() => {
             $(this).trigger('submit');
        }, 2000)

      }

      if (response.details === 'existing-inactive') {

         $('#authDetails').show();
         $('#wrong_pass').hide();
         $('#existing_account').hide();
         $('#account_activation').css('display', 'inline');
      
      }
      
      
    }
  });
})

$(function () {
  
// $('#customer_login').attr('action', '');
 $('#create_customer').attr('action', '');
 $('#customer_login').attr('action', '');
// $('#RecoverEmail').closest('form').attr('action', '');

});